export default {
      id: "discord-usage",
      viewBox: "0 0 512 512",
      url: "../../assets/" + "sprite.svg#discord-usage",
      toString: function () {
        return this.url;
      }
    }